module.exports = __webpack_public_path__ + "static/media/Infinity.53c05bbb.png";